/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';

const LineWidthPicker = ({ onWidthSelect, selLine }) => {
	const lines = Array.from({ length: 8 }, (_, index) => index + 1);
	const [selectedLine, setSelectedLine] = useState(selLine);

	const handleLineClick = (lineNumber) => {
		setSelectedLine(lineNumber);
		if (onWidthSelect) {
			onWidthSelect(lineNumber); // Notify parent component of the selected line width
		}
	};

	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
			{lines.map((lineNumber) => (
				<div
					key={lineNumber}
					onClick={() => handleLineClick(lineNumber)}
					style={{
						display: 'flex',
						alignItems: 'center',
						margin: '5px 0',
						cursor: 'pointer',
						backgroundColor: selectedLine === lineNumber ? '#e0e0e0' : 'transparent',
						padding: '5px',
						borderRadius: '4px',
					}}
				>
					<span style={{ marginRight: '10px' }}>{lineNumber}</span>
					<hr
						style={{
							width: '100px',
							border: `${lineNumber / 2}px solid black`, // Increase width with line number
							margin: 0,
						}}
					/>
				</div>
			))}
		</div>
	);
};

export default LineWidthPicker;